/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import styled from 'styled-components'
import { P as p, Typography } from 'common/typography'
import Topic from 'components/privacity/topic'

const P = styled(p)`
  line-height: 28px;
`

const PrivacityStyled = styled.div`
  padding-block-start: 48px;
  padding-block-end: 80px;
  h1 {
    color: var(--neutral10);
  }
`

function Privacity({ topic, index, refGrid }) {
  return (
    <PrivacityStyled>
      <Typography small="headline4" large="headline3" as="h1">Política de privacidad</Typography>
      <div className="content" ref={refGrid}>
        <Topic title="Introducción" id="introduccion">
          <P>
            Hola, ¿cómo estás? Mi nombre es Leónidas Esteban y en este website /
            aplicación / portafolio aprendes a dominar JavaScript. La política
            de privacidad está creada para ayudarte a entender como se va a usar
            la información que proveas al canal.
          </P>
        </Topic>
        <Topic title="Recolección automática de datos" id="datos">
          <P>
            Podrás usar el website de forma anónima, sin embargo
            leonidasesteban.com puede tomar cierta información personal para el
            uso de nuestros servicios. Por ejemplo leonidasesteban.com puede
            recolectar información de el tipo de navegador para personalizar su
            experiencia, o su dirección IP y datos enviados automáticamente por
            Google Analytics para medir el tráfico de la página.
          </P>
        </Topic>
        <Topic title="Cookies" id="cookies">
          <P>
            Cuando usted visita nuestro Website o pulsa cualquier hipervínculo
            que aparece en ella, o usa uno o más de nuestros servicios, podremos
            usar una tecnología industrial llamada "cookies" la cual almacena
            cierta información en su computadora y que nos permitirá
            personalizar su experiencia para alinearla con sus intereses y
            preferencias o simplemente facilitar su acceso al usar nuestros
            servicios. La mayoría de los Navegadores permitirán que usted
            elimine o bloquee las "cookies" de su computador o su disco duro o
            alertará las mismas cuando estas se activen. Por favor refiérase a
            las instrucciones de su Navegador para ayuda o para conocer mejor
            sus funciones. Por favor note, sin embargo, que si usted bloquea de
            su Navegador el uso de estos cookies, el servicio no podrá ser
            utilizado o no podrá acceder a nuestro Website o quizás pueda
            afectar el funcionamiento de la página como tal.
          </P>
        </Topic>
        <Topic title="Ofrecer un mejor producto y servicio" id="servicio">
          <P>
            Este website tiene como propósito principal ser una red de distribución
            efectiva de conocimiento, toda la información suministrada por el
            usuario solo será usada para mejorar su experiencia e identificar
            sus acciones dentro de la aplicación.
          </P>
        </Topic>
        <Topic title="Comunicarnos contigo" id="comunicacion">
          <P>
            Para mantenerte informado de nuevo contenido o actualizaciones de
            la aplicación podríamos enviarte correos electrónicos.
          </P>
        </Topic>
        <Topic
          title="Servicios de terceros con los cuales compartimos información del usuario"
          id="servicios"
        >
          <P>1. Google Analytics - Estadísticas</P>
          <P>2. Google OAuth - Autenticación</P>
        </Topic>
        <Topic title="Seguridad" id="seguridad">
          <P>
            Usamos métodos razonables de seguridad para proteger la data que
            reside en nuestros servidores. Sin embargo, ningún sistema de
            seguridad es impenetrable, debido a esto, no le podemos garantizar
            la seguridad de nuestros servidores. Es también posible que la
            información que usted nos provea pueda ser interceptada durante la
            transmisión de datos.
          </P>
          <br />
          <P>
            Cada vez que usted le dé a leonidasesteban.com información sensible
            (ejemplo: contraseñas, etc), leonidasesteban.com tomará medidas
            comerciales razonables para proteger dicha información y establecer
            una conexión segura con nuestro Navegador de Web.
            leonidasesteban.com emplea una tecnología industrial estándar
            conocida como secure-socket-layer ("SSL") para proteger la
            transmisión de información de pago al Website. Puede usted chequear
            la seguridad de su conexión tras observar la barra de direcciones en
            su ventana de Navegador. Cuando usted acceda un servidor protegido
            por SSL, los primeros caracteres de la dirección cambiaran de "http"
            a "https."
          </P>
        </Topic>
        <Topic title="Niños" id="menores">
          <P>
            En cumplimiento del Acta Federal de 1998 para la Privacidad On-line
            y la Protección de Niños (COPPA), no pediremos conscientemente
            información personal de ninguna persona menor a trece (13) años sin
            el consentimiento de sus padres. Cualquier persona que nos
            proporciona este tipo de información representa que tiene 13 o más
            años de edad.
          </P>
        </Topic>
      </div>
    </PrivacityStyled>
  )
}

export default Privacity
